import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';
export const findSkuList= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/sku/agent?`+params,
        method: 'GET'
    })
}
export const addProductSku = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/sku`,
        method: 'POST',
        data: data
    })
}
export const updateProductSku = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/sku`,
        method: 'PUT',
        data: data
    })
}
export const delProductSku = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-product/v1/sku/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}
export const findProductSkuClassify= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/sku/list?`+params,
        method: 'GET'
    })
}
export const findConstituteBySkuId= (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/sku/constitute/${id}`,
        method: 'GET'
    })
}